import Vue from 'vue';
import Router from 'vue-router';
import Login from './authentication/components/Login.vue';
import auth from './authentication/services/auth';
import Demo from './demo/Demo.vue';
import DemoKrz from './demo/DemoKrz.vue';

Vue.use(Router);

import RegistrationRoutes from './registration/registration_routes';
import SupportRoutes from './support/support_routes';

let routes = [
    { path: '/', redirect: '/register' },
    { path: '/krz', redirect: '/registerkrz' },
    { path: '/login', name: 'Login', component: Login },
    { path: '/demo', name: 'Demo', component: Demo },
    { path: '/demokrz', name: 'DemoKrz', component: DemoKrz },
    {
        path: '/logout',
        beforeEnter(to, from, next) {
            auth.logout();
            next('/login');
        }
    }
];

routes = routes.concat(RegistrationRoutes, SupportRoutes);

const router = new Router({ mode: 'history', routes: routes });

export default router;
